import { makeStyles } from '@material-ui/core'
import { TabGroup, Typography } from 'procyon-ui'
import React, { useEffect, useState } from 'react'
import { SearchInput } from 'V2Components'
import DeviceList from 'Views/DeviceList'

const DeviceTabs = () => {
  const [searchKey, setSearchKey] = useState('')
  return (
    <>
      <div className='flex items-center justify-between'>
        <Typography style={{ color: 'var(--color-font-base)' }} variant='h3'>
          Approved Onboarded Devices
        </Typography>
        <SearchInput sx={{ width: '280px' }} searchKey={searchKey} onChange={setSearchKey} />
      </div>
      <div className='bg-[var(--color-common-bg-base)] p-5 mt-4'>
        <DeviceList tab='APPROVED' searchKey={searchKey} />
      </div>
    </>
  )
}

export default DeviceTabs
